import { Injectable } from "@angular/core";
import { LocalStorageService } from "../../../shared/services/LocalStorage.service";

@Injectable({
  providedIn: "root",
})
export class SettingsPageService {

  constructor(
    private localStorageService: LocalStorageService
  ) {
  }


  setSelectedTab(tab: number) {
    this.localStorageService.setSettingsSelectedTab(tab.toString());
  }

  getSelectedTab(): number {
    const tabSelected = this.localStorageService.getSettingsSelectedTab();
    const tab = tabSelected != null ? parseInt(tabSelected, 10) : 0;
    return tab;
  }

}
